import { apiClient } from '../client'
import { ApplicationSettings } from './types'

export const getApplicationSettings = async (): Promise<ApplicationSettings> => {
    const response = await apiClient('v1/core/application-settings')
    return response.data
}
